import { render, staticRenderFns } from "./lawyerDetail.vue?vue&type=template&id=2252d9ae&scoped=true&"
import script from "./lawyerDetail.vue?vue&type=script&lang=tsx&"
export * from "./lawyerDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./lawyerDetail.vue?vue&type=style&index=0&id=2252d9ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252d9ae",
  null
  
)

export default component.exports